import React from 'react';
import { weekDays } from '../../TransferenciaAgendamento/constants';
import ClickableTablecell from '../components/ClickableTablecell';
import { TableCellText } from '../components/ClickableTablecell/styles';

export const getConvenioTableHeader = ({ onClick }) => {
  return [
    {
      Header: 'Horário',
      getValue: row => row.horaInicio,
      props: { center: 'true' },
    },
    ...weekDays.map(({ value }, dayIndex) => ({
      Header: value.substring(0, 3),
      getValue: (row, rowIndex) => {
        const isDisabled = !row[value]?.permiteAgendamento;
        const handleClick = () => onClick(row[value]);
        const conveniosCount = row[value]?.convenios?.length || 0;
        const label = conveniosCount > 0 ? `${conveniosCount} conv.` : '';

        return (
          <ClickableTablecell id={`cfg-cvt-cel-${value}-${rowIndex}`} disabled={isDisabled} onClick={!isDisabled && handleClick}>
            <TableCellText style={label ? { fontWeight: 500 } : undefined}>
              {label || (isDisabled ? '' : '—')}
            </TableCellText>
          </ClickableTablecell>
        );
      },
      center: 'true',
      isClick: true,
    })),
  ];
};
